import React from "react";
import { createRoot } from "react-dom";

// import VideoPlayer from "../components/VideoPlayer";
import { jsonParse } from "./../../../wp-utils/v1";
import Playlist from "./Playlist";

import "./playlist.scss";
import PlaylistSimple from "./playlist/PlaylistSimple.js";
import PlaylistClassic from "./playlist/PlaylistClassic.js";
// import PlaylistSimple from "./playlist/PlaylistSimple";

document.addEventListener("DOMContentLoaded", function () {
  renderVideo();
});

export const FrontEnd = (props) => {
  const { playlistType } = props.attributes;

  if (playlistType === "simplelist") {
    return <PlaylistSimple {...props} />;
  }
  if (playlistType === "listwithposter") {
    return <PlaylistClassic {...props} />;
  }
  return <Playlist {...props} />;
};

export const renderVideo = () => {
  const players = document.querySelectorAll(".h5vp_playlist");

  players?.forEach((item) => {
    const attributes = jsonParse(item.dataset.attributes);
    item.removeAttribute("data-attributes"); // remove
    item.removeAttribute("data-data"); // remove

    if (!attributes) {
      return false;
    }
    const nonce = item.dataset.nonce;
    if (typeof attributes === "object" && item) {
      const root = createRoot(item);
      root.render(<FrontEnd attributes={attributes} nonce={nonce} />);
    }
  });
};
